<template>
    <div class="row" style="width: 95%">
        <div class="col justify-content-center align-content-center">
            <div class="spacer" />
            <div id="creativity-container" class="pr-8 pr-sm-0">
                <div id="planet-ring" />
                <div id="creativity" />
            </div>

            <div class="text-container pr-7 pr-sm-0">
                <div id="center-text">
                    <div class="header">{{ $t('message.solarSystem.keyValue3') }}</div>
                    <div class="subtext">{{ $t('message.solarSystem.keyValue3txt') }}</div>
                </div>
            </div>

            <div class="spacer" />

            <div id="equality-container" class="pl-8 pl-sm-0">
                <div id="equality">
                    <img src="/static/images/planets/planet-equality.svg">
                </div>
            </div>

            <div style="height: 65px;" /> <!-- Spacer for the equality planet, which is not made up the same way as the others -->

            <div class="text-container pl-7 pl-sm-0">
                <div id="center-text">
                    <div class="header">{{ $t('message.solarSystem.keyValue5') }}</div>
                    <div class="subtext">{{ $t('message.solarSystem.keyValue5txt') }}</div>
                </div>
            </div>
        </div>

        <div class="col">
            <div class="spacer-large"/>

            <div id="pluralism-container" class="pr-8 pr-sm-0">
                <div id="pluralism">
                    <img src="/static/images/planets/pluralism.svg">
                </div>
            </div>

            <div class="text-container pr-7 pr-sm-0">
                <div id="center-text">
                    <div class="header">{{ $t('message.solarSystem.keyValue2') }}</div>
                   <div class="subtext">{{ $t('message.solarSystem.keyValue2txt') }}</div>
                </div>
            </div>

            <div class="spacer" />

            <div id="tech-for-humanity-container" class="pl-8 pl-sm-0">
                <div id="tech-for-humanity">
                    <img src="/static/images/planets/planet-humanmachine.svg">
                </div>
            </div>

            <div class="text-container pl-7 pl-sm-0">
                <div id="center-text">
                    <div class="header">{{ $t('message.solarSystem.keyValue4') }}</div>
                    <div class="subtext">{{ $t('message.solarSystem.keyValue4txt') }}</div>
                </div>
            </div>
        </div>

        <div class="w-100 spacer"/>

        <div class="col">
            <div id="fellowship-container" class="pr-8 pr-sm-0">
                <div id="moon-2"/>

                <div id="fellowship">
                    <div id="moon-orbit">
                        <div id="moon"/>
                    </div>
                </div>
            </div>

            <div class="text-container pr-7 pr-sm-0">
                <div id="center-text">
                    <div class="header">{{ $t('message.solarSystem.keyValue1') }}</div>
                     <div class="subtext">{{ $t('message.solarSystem.keyValue1txt') }}</div>
                </div>
            </div>

            <div class="spacer"/>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SolarSystemMobile',
  data() {
    return {};
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/main.scss';

$planet-width: 90px;

%planet {
  position: absolute;
  width: $planet-width;
  height: $planet-width;

  img {
    width: $planet-width;
  }
}

.spacer {
    height: $planet-width/3;
}

.spacer-large {
    height: $planet-width;

    @media screen and (max-width: 575px){
        height: $planet-width/2;
    }

}

.text-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

#center-text {
 width: 10rem;

  .subtext {
      font-size: 0.8rem;
      color: rgb(154, 168, 175);
      font-family: 'Lato' !important;
  }

  .header {
    font-size: 1rem;
    color: rgb(243, 243, 243);
    font-weight: 600;
    margin: 0.8rem 0;
    font-family: 'Lato' !important;
  }
}

%planet-container {
  height: $planet-width;

  display: flex;
  justify-content: center;
  align-items: center;
}

#fellowship-container {
  @extend %planet-container;
}

#fellowship {
  @extend %planet;

  border-radius: 50%;
  border: 1px solid rgb(221, 221, 221);
  background-color: $dark-blue;

  z-index: 2;
}

#moon{
  width:15px;
  height:15px;

  border-radius: 50%;
  border: 1px solid rgb(221, 221, 221);

  background-color: $dark-blue;
  position:absolute;
}

#moon-orbit{
  bottom: -10px;
  position:absolute;

  width: 100px;
  height: 100px;

  border-radius:100%;

  -webkit-animation: spin 5s linear infinite;
  animation: spin 5s linear infinite;
}

#moon-2 {
  position:absolute;

  border-radius: 50%;
  border: 1px solid rgb(221, 221, 221);

  width:20px;
  height:20px;

  z-index:3;

  background-color: $dark-blue;
  animation: moon-2-orbit 7s infinite ease-in-out;
}

@include orbit('moon-2-orbit', -45px, -45px, 45px, 45px);

#pluralism-container {
  @extend %planet-container;

  img {
    width: 100%;
  }
}

#pluralism {
  @extend %planet;
}

#creativity-container {
  @extend %planet-container;
}

#creativity{
  @extend %planet;

  border-radius: 50%;
  border: 1px solid rgb(221, 221, 221);
  background-color: $dark-blue;

  z-index: 2;
}

#planet-ring {
  position: absolute;
  z-index: 3;
  height: .35*$planet-width;
  width: 1.65*$planet-width;
  border-radius: 50%;
  border: 1px solid rgb(221, 221, 221);
  animation: ring-bob 1s infinite ease-in-out alternate;
}

#tech-for-humanity-container {
  @extend %planet-container;
}

#tech-for-humanity {
  @extend %planet;

  border-radius: 50%;
  img {
    width: 100%;
  }

  animation: pulse 1.5s infinite alternate;
}

#equality-container {
  @extend %planet-container;

  img {
    width: 130%;
    height: auto;
  }
}

#equality {
  @extend %planet;
}

</style>
